import axios from 'axios'

//  账号管理新增
export function addUserRole (datas) {
  const url = `/customerPermission/addUserRole`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 账号管理恢复/禁用
export function deleteUserAccount (datas) {
  const url = `/customerPermission/deleteUserAccount`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 账号管理编辑提交
export function editUserRole (datas) {
  const url = `/customerPermission/editUserRole`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 账号管理分页查询
export function queryAccountPage (datas) {
  const url = `/customerPermission/queryAccountPage`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 服务平台查询
// export function queryPlatformList (datas) {
//   const url = `/customerPermission/queryPlatformList`
//   return new Promise((resolve, reject) => {
//     axios.get(url, {params: datas}).then((res) => {
//       resolve(res)
//     }).catch((err) => {
//       reject(err)
//     })
//   })
// }

// 客服分组查询
export function queryGroupList (datas) {
  const url = `/customerPermission/queryGroupList`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 客服角色查询
export function queryRoleList (datas) {
  const url = `/customerPermission/queryRoleList`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 账号管理编辑回显
export function editUserRoleReturn (datas) {
  const url = `/customerPermission/editUserRoleReturn`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 重置密码
export function resetUserPwd (datas) {
  const url = `/customerPermission/resetUserPwd`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 查询用户查看权限
export function queryUserDataPermission (datas) {
  const url = `/customerPermission/queryUserDataPermission`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 更新用户数据权限
export function updateUerDataPermission (datas) {
  const url = `/customerPermission/updateUerDataPermission`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/power/account.js